export const SetLocalStorage = (name: string, value: string) => {
    localStorage.setItem(name, value)
}

export const GetLocalStorage = (name: string): string | null => {
    return localStorage.getItem(name)
}
